import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-global-alert"]
const _hoisted_2 = {
  key: 0,
  class: "flex-col items-start gap-2.5 inline-flex justify-evenly"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex flex-col justify-evenly" }
const _hoisted_5 = ["src", "alt"]

import { computed, ref } from 'vue';
import { IGlobalAlert } from '@/interfaces/forms/global-alert.interface';
import { GlobalAlertTypes } from '@/enums/global-alerts.enum';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalAlert',
  props: {
    type: {},
    content: {},
    visibility: {}
  },
  emits: ["closeAlert"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const closed = ref(false);
const alertDiv = ref<HTMLDivElement>();

const emit = __emit;

const iconMap = {
  information: require('@/assets/icons/info-icon-white.svg'),
  warning: require('@/assets/icons/warning-icon-black.svg'),
  error: require('@/assets/icons/danger-icon-white.svg'),
  default: require('@/assets/icons/info-icon-black.svg'),
};

const closeIconMap = {
  information: require('@/assets/icons/white-cross.svg'),
  warning: require('@/assets/icons/dark-cross.svg'),
  error: require('@/assets/icons/white-cross.svg'),
  default: require('@/assets/icons/dark-cross.svg'),
};

const foreColorMap = {
  information: 'text-racq-true-white [&>*]:text-racq-true-white',
  warning: 'text-racq-dark-grey  [&>*]:text-racq-dark-grey',
  error: 'text-racq-true-white [&>*]:text-racq-true-white',
  default: 'text-racq-dark-grey  [&>*]:text-racq-dark-grey',
};

const backgroundColorMap = {
  information: 'bg-racq-blue',
  warning: 'bg-racq-yellow',
  error: 'bg-racq-error-red',
  default: 'bg-racq-pale-blue',
};

const icon = computed(() => {
  let icon = iconMap[props.type?.toLowerCase() as GlobalAlertTypes];
  return icon ?? iconMap.default;
});

const closeIcon = computed(() => {
  let icon = closeIconMap[props.type?.toLowerCase() as GlobalAlertTypes];
  return icon ?? closeIconMap.default;
});

const foreColor = computed(() => foreColorMap[props.type?.toLowerCase() as GlobalAlertTypes]);

const backgroundColor = computed(() => {
  const type = props.type?.toLowerCase() as GlobalAlertTypes;
  let bgColour = backgroundColorMap[type];
  return bgColour ?? backgroundColorMap.default;
});

function handleClose() {
  closed.value = true;
  emit('closeAlert', alertDiv.value);
}

return (_ctx: any,_cache: any) => {
  return (!closed.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "alertDiv",
        ref: alertDiv,
        class: _normalizeClass(['flex w-full py-4 sm:px-4 lg:px-5 sm:gap-3 lg:gap-4 min-h-14', backgroundColor.value]),
        "data-global-alert": _ctx.type
      }, [
        (!!icon.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: icon.value,
                alt: `${_ctx.type} icon`,
                class: "w-[16px] h-[16px]"
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(RichText), {
          field: { value: _ctx.content },
          class: _normalizeClass(["flex flex-col flex-grow !inline-block justify-evenly sm:mt-0.5", ['sm:text-m-bold lg:text-base-bold', foreColor.value]])
        }, null, 8, ["field", "class"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", { onClick: handleClose }, [
            _createElementVNode("img", {
              src: closeIcon.value,
              alt: `${_ctx.type} close icon`,
              class: "w-[10px] h-[10px]"
            }, null, 8, _hoisted_5)
          ])
        ])
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})